import React, { useState, useEffect } from 'react';
import { Phone, Menu, X, Sparkles, MessageCircle } from 'lucide-react';
import { contactInfo } from '../mockData';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'glass-dark py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-yellow-600 via-yellow-500 to-amber-600 flex items-center justify-center shadow-lg animate-glow">
              <Sparkles className="text-white" size={24} />
            </div>
            <div>
              <h1 className="text-white text-xl md:text-2xl font-bold display-font">Marabout Belgique</h1>
              <p className="text-yellow-500 text-xs serif-font">Voyance & Spiritualité</p>
            </div>
          </div>
          
          <div className="hidden lg:flex items-center space-x-8">
            <a href="#services" className="text-white hover:text-yellow-500 transition-colors font-medium">
              Services
            </a>
            <a href="#temoignages" className="text-white hover:text-yellow-500 transition-colors font-medium">
              Témoignages
            </a>
            <a href="#villes" className="text-white hover:text-yellow-500 transition-colors font-medium">
              Villes
            </a>
            <a href="#contact" className="text-white hover:text-yellow-500 transition-colors font-medium">
              Contact
            </a>
          </div>
          
          <div className="flex items-center space-x-3">
            <a 
              href={`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-5 py-3 rounded-full font-semibold transition-all"
            >
              <MessageCircle size={18} />
              <span>WhatsApp</span>
            </a>
            
            <a 
              href={`tel:${contactInfo.phone}`}
              className="hidden md:flex items-center space-x-2 luxury-button text-white px-5 py-3 rounded-full font-semibold"
            >
              <Phone size={18} />
              <span>{contactInfo.phone}</span>
            </a>
            
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white p-2"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
        
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 glass rounded-2xl p-6 space-y-4 animate-fadeInUp">
            <a href="#services" className="block text-white hover:text-yellow-500 transition-colors font-medium py-2" onClick={() => setMobileMenuOpen(false)}>
              Services
            </a>
            <a href="#temoignages" className="block text-white hover:text-yellow-500 transition-colors font-medium py-2" onClick={() => setMobileMenuOpen(false)}>
              Témoignages
            </a>
            <a href="#villes" className="block text-white hover:text-yellow-500 transition-colors font-medium py-2" onClick={() => setMobileMenuOpen(false)}>
              Villes
            </a>
            <a href="#contact" className="block text-white hover:text-yellow-500 transition-colors font-medium py-2" onClick={() => setMobileMenuOpen(false)}>
              Contact
            </a>
            <a 
              href={`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-2 bg-green-600 text-white px-6 py-3 rounded-full font-semibold w-full"
            >
              <MessageCircle size={18} />
              <span>WhatsApp</span>
            </a>
            <a 
              href={`tel:${contactInfo.phone}`}
              className="flex items-center justify-center space-x-2 luxury-button text-white px-6 py-3 rounded-full font-semibold w-full"
            >
              <Phone size={18} />
              <span>{contactInfo.phone}</span>
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;